export const EMPLOYEE_ROLES = {
  'Aanmelden': 'Aanmelden',
  'Admin': 'Admin',
  'Apothekers': 'Apothekers',
  'Autoriseren': 'Autoriseren',
  'Inschrijven': 'Inschrijven',
  'Klantondersteuning': 'Klantondersteuning',
  'Logistiek': 'Logistiek',
  'Marketing': 'Marketing',
  'Medicijnabonnement': 'Medicijnabonnement',
  'Plannen & Bestellen': 'Plannen & Bestellen',
  'TeamLeads': 'TeamLeads',
  'Tech': 'Tech',
} as const

export type EmployeeRole = (typeof EMPLOYEE_ROLES)[keyof typeof EMPLOYEE_ROLES]
